import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class OilCollectionService extends ApiService {

  constructor(private http: HttpClient) {
    super(http);
    this.apiURL += '/oil-collections';
    this.apiURLv2 += '/oil-collections';
  }

  getRoutes(entity: any) {
    return this.http.post(`${this.apiURL}/get_routes`, entity, this.headers);
  }

  saveRoute(entity: any) {
    return this.http.post(`${this.apiURL}/save_route`, entity, this.headers);
  }

  async exportOilColletionsReportExcel(data: any): Promise<any> {
    return await this.http.post(`${this.apiURLv2}/generate-oil-collection-report`, data, this.headers).toPromise();
  }

  getOilCollectionReportData(payload: { startDate: string, endDate: string, clients: string[] }) {
    return this.http.post(`${this.apiURLv2}/get-oil-collection-report-data`, payload, this.headers);
  }

  getAllPaginated(params: any): Promise<any> {
    return this.http.get<any>(`${this.apiURL}`, { headers: this.headers.headers, params }).toPromise();
  }

  async exportCollectionsSimple(startDate: string, endDate: string): Promise<any> {
    return await this.http
      .post(`${this.apiURLv2}/export-collections-excel`, { startDate, endDate }, this.headers)
      .toPromise();
  }

  /**
   * Moves one or more oil collections to a different client.
   * Mirrors the backend contract exactly: only `collection_ids` +
   * `new_client_ident_GUI` — the front never sends the legacy full-client-swap
   * mode (`source_client_ident_GUI`).
   */
  transferCollectionsToClient(payload: { collection_ids: string[]; new_client_ident_GUI: string }): Promise<any> {
    return this.http
      .put<any>(`${this.apiURL}/update-client`, payload, this.headers)
      .toPromise();
  }

}

